import React from "react";

interface CustomPlaceholderProps {
  text: string;
}

export const CustomPlaceholder: React.FC<CustomPlaceholderProps> = ({ text }) => {
  return <span className="text-[#6b7280]">{text}</span>;
};
